<template>
  <div>
    <div class="unit-box">
      <div class="unit-header a" v-if="title">
        <slot name="title">
          <span class="unit-title">{{ title }}</span>
          <span v-if="dataNum" class="Year-To-Date">年累计 {{ dataNum }}</span>
          <template v-if="tip">
            <el-popover
              placement="top-start"
              trigger="hover"
              class="tipsBox"
            >
              <div class="tips">
                <div>
                  <div class="icon_principal"></div>
                  <span class="tips_title">负责人</span>
                  <span class="tips_content">{{ tips.principal }}</span>
                </div>
                <div>
                  <div class="icon_source"></div>
                  <span class="tips_title">数据来源</span>
                  <span class="tips_content">{{ tips.source }}</span>
                </div>
                <div>
                  <div class="icon_Remark"></div>
                  <span class="tips_title">更新规则</span>
                  <span class="tips_content">{{ tips.Remark }}</span>
                </div>
                <div v-if="tips.source1">
                  <div class="icon_Remark show"></div>
                  <span class="tips_title"></span>
                  <span class="tips_content">{{ tips.source1 }}</span>
                </div>
              </div>
              <i class="el-icon-info" slot="reference"></i>
            </el-popover>
          </template>
        </slot>
        <span class="unit-header_sub-title" v-if="subTitle">{{ subTitle }}</span>
        <span class="unit-header__icon" v-if="icon">手动</span>
        <slot name="sub-title"></slot>
        <slot name="create-task"></slot>
      </div>
      <div class="unit-body"><slot></slot></div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    dataNum: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    icon: {
      type: Boolean,
      default: false
    },
    tip: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      list: [
        {
          title: '总体营收',
          principal: '冯轲',
          source: '业财数据',
          Remark: '每天10:40更新 T-1数据'
        },
        {
          title: '内容价值',
          principal: '王雷',
          source: '大数据平台',
          Remark: '每天10:00更新 T-1数据'
        },
        {
          title: '大内容事业部',
          principal: '冯轲，王雷',
          source: '业财数据，大数据平台',
          Remark: '业财每天10:40更新 T-1数据,',
          source1: '大数据每天10点更新 T-1数据'
        },
        {
          title: '拓展终端态势',
          principal: '王雷',
          source: '大数据平台',
          Remark: '每天10:00更新 T-1数据'
        },
        {
          title: '数字营销事业部',
          principal: '冯轲，许建新',
          source: '业财数据，广告系统',
          Remark: '业财每天10:40更新 T-1数据,',
          source1: '广告系统每天6点更新 T-1数据'
        },
        {
          title: '语音业务',
          principal: '李凯',
          source: '南京智屏',
          Remark: '每天10:00更新 T-1数据'
        },
        {
          title: '系统拓展事业部',
          principal: '冯轲，王雷',
          source: '业财数据，大数据平台',
          Remark: '业财每天10:40更新 T-1数据,',
          source1: '大数据每天10点更新 T-1数据'
        },
        {
          title: '投影仪',
          principal: '冯轲',
          source: '业财数据',
          Remark: '每天10:40更新 T-1数据'
        },
        {
          title: '开机广告城市售出率',
          principal: '许建新',
          source: '广告系统',
          Remark: '广告系统每天6点更新 T-1数据'
        },
        {
          title: '代理商贡献占比',
          principal: '许建新',
          source: '广告系统',
          Remark: '广告系统每天6点更新 T-1数据'
        }
      ],
      tips: {}
    }
  },
  created () {
  },
  mounted () {
    for (var i = 0; i < this.list.length; i++) {
      if (this.list[i].title === this.title) {
        this.tips = Object.assign(this.tips, this.list[i])
      }
    }
  }
}
</script>
<style lang="stylus" scoped>
.unit-header
  background #1F1E44
  line-height 2.5rem
  height 2.5rem
  font-size 1rem
  color #fff
  padding 0 1.5rem
  border-radius .5rem .5rem 0 0
  position relative
  display flex
  align-items center
  .unit-header__icon,.unit-header_sub-title
    background rgba(24,150,255, .4)
    color rgba(255,255,255,.8)
    border 1px solid rgba(24,150,255, .6)
    font-size .7rem
    line-height 1.2rem
    padding 0 .5rem
    border-radius .3rem
  .unit-header_sub-title
    font-size .8rem
    // color rgba(255, 255, 255, .6)
    float right
  .unit-title
    // margin-right: auto
    margin-right: 0.5rem!important

.unit-body
  background #1C1839
  border-radius 0 0 .5rem .5rem
.icon_principal,.icon_source,.icon_Remark
  display: inline-block
  width .4rem
  height .4rem
  border-radius 50%
  margin-right .2rem

.icon_principal
  background #EA4AD3
.icon_source
  background #0080FF
.icon_Remark
  background #7D4AEA
.tipsBox
  margin-right auto
.tips_title
  font-size 0.6rem
  display inline-block
  width 2.4rem
  margin-right 1rem
.tips_content
  font-size 0.7rem
  font-weight 500
.Year-To-Date
  margin-right: 0.4rem
  height: 1.2rem;
  line-height: 1.2rem;
  background: #272557;
  border-radius: 0.2rem;
  color: rgba(255,255,255,0.6);
  font-size: 0.8rem;
  display: inline-block;
  padding: 0 0.4rem;
  background: #272557;
.show
  background: transparent;
</style>
